export default (state = [], action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.question_ids) {
        return payload.question_ids;
      }
      return state;
    }
  }
};
